var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang-wrap",on:{"click":function($event){return _vm.$router.push('/Language')}}},[_c('img',{staticClass:"lang-img",attrs:{"src":_vm.languageIcon,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }